// type xác nhận thỏa thuận/ chính sách => dùng để xem lịch sử
export default {
  TermsOfServiceType: 1,
  PrivacyType: 2,
  TermsOfPurchaseType: 3,
};
